import React from 'react'
import { useTabsNavigation, CrudTabs, CrudRoute } from 'elentari'
import UnidadeNegocioForm from './UnidadeNegocioForm'

import AnalistaUnidadeNegocio from './Analistas/AnalistaUnidadeNegocio'
import AnalistaUnidadeNegocioForm from './Analistas/AnalistaUnidadeNegocioForm'

function UnidadeNegocioTabs() {
  const tabsNavigation = useTabsNavigation({
    mainPath: 'unidadeNegocio',
    tabs: [
      { value: '', label: 'Unidade de Negocio' },
      { value: 'analistasPreferenciais', label: 'Analistas Preferenciais' }
    ]
  })
  return (
    <CrudTabs {...tabsNavigation}>
      <div>
        <CrudRoute render={props => <UnidadeNegocioForm {...props} />} />
        <CrudRoute
          name="analistasPreferenciais"
          render={props => (
            <AnalistaUnidadeNegocio
              onClickNew={tabsNavigation.toNewChild}
              onClickEdit={tabsNavigation.toEditChild}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="analistasPreferenciais"
          isForm
          render={props => <AnalistaUnidadeNegocioForm {...props} />}
        />
      </div>
    </CrudTabs>
  )
}

export default UnidadeNegocioTabs
